<template>
  <section>
    <div id="step-info" class="container">
      <div class="ws-textbox mb-4">
        <h2 class="title-choose-photo">
          <u>{{ lang.taxi['SFS_LANG_PHOTO2CLAIM_22'] }}</u>
        </h2>
        <div v-if="taxiInfo.bank_info">
          <p class="bank-info">
            <span class="mr-2 pay-info-bold">{{ lang.taxi['SFS_LANG_PHOTO2CLAIM_23'] }}:</span>
            <span>{{ taxiInfo.bank_info.transfer_bank_info['Account Holder Name'] }}</span>
          </p>
          <p v-if="taxiInfo.bank_info.transfer_bank_info.Type == 'Email'" class="bank-info">
            <span class="mr-2 pay-info-bold">{{ lang.taxi['SFS_LANG_PHOTO2CLAIM_36'] || 'Email' }}:</span>
            <span>{{ taxiInfo.bank_info.transfer_bank_info['Email'] }}</span>
          </p>
          <p v-else class="bank-info">
            <span class="mr-2 pay-info-bold">{{ lang.taxi['SFS_LANG_PHOTO2CLAIM_24'] }}:</span>
            <span>{{
              taxiInfo.bank_info.transfer_bank_info[' I B A N'] || taxiInfo.bank_info.transfer_bank_info['Account Number']
            }}</span>
          </p>
        </div>
        <h2 class="title-choose-photo mt-3">
          <u>{{ lang.taxi['SFS_LANG_PHOTO2CLAIM_25'] }}</u>
        </h2>
        <div v-if="taxiInfo.bank_info.transfer_bank_info">
          <p class="amount-info">
            <span class="mr-2 pay-info-bold">{{ lang.taxi['SFS_LANG_PHOTO2CLAIM_26'] }}:</span>
            <span> {{ taxiCurrency }} {{ formatPrice(creditAmount) }}</span>
          </p>
          <p v-for="(item, index) in taxiInfo.list_receipt" :key="index" class="amount-info">
            <span class="mr-2 pay-info-bold">{{ lang.taxi['SFS_LANG_PHOTO2CLAIM_27'] }}:</span>
            <span>{{ item.currency }} {{ item.amount }}</span>
          </p>
          <p class="amount-info">
            <span class="mb-3 pay-info-bold">{{ lang.taxi['SFS_LANG_PHOTO2CLAIM_28'] }}:</span>
            <span> {{ taxiInfo.bank_info.currency }} {{ taxiInfo.bank_info.target_amount }}</span>
          </p>
        </div>
      </div>
      <div class="button-download text-center">
        <div class="btn-handle">
          <button class="btnDefault btn-email" @click="onOpenEmailPopup()">
            {{ lang.taxi['SFS_LANG_PHOTO2CLAIM_29'] }}
          </button>
        </div>
      </div>
    </div>
    <b-modal v-model="isOpenPopup" :modal-class="'ws-modal'" centered>
      <div class="d-flex flex-column align-items-center">
        <template v-if="step == 1">
          <p class="mb-2">
            {{ lang.taxi['SFS_LANG_PHOTO2CLAIM_30'] }}
          </p>
          <input
            v-model="pax.email_address"
            required
            placeholder="Email"
            type="email"
            class="p-2 input-email-monetary"
            @focus="resetEmailValidate()"
          />
          <p v-if="!isEmailValidate" style="color: red">{{ lang.taxi['SFS_LANG_PHOTO2CLAIM_34'] }}</p>
        </template>
        <template v-else-if="step == 2">
          <i style="color: #74d009; font-size: 5rem; margin-bottom: 1rem" class="fas fa-check-circle"></i>
          <p>{{ lang.taxi['SFS_LANG_PHOTO2CLAIM_31'] }}</p>
        </template>
      </div>
      <template #modal-footer>
        <div v-if="step == 1" class="ws-modal__footer w-100">
          <button class="btnDefault" @click="isOpenPopup = !isOpenPopup">{{ lang.taxi['SFS_LANG_PHOTO2CLAIM_32'] }}</button>
          <button class="btnDefault" @click="sendEmailConfirm()">{{ lang.taxi['SFS_LANG_TRANSFER_WISE_7'] }}</button>
        </div>
        <div v-else></div>
      </template>
    </b-modal>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import { replaceStr } from '@/utils/helper'

export default {
  name: 'StepInfo',
  components: {},
  props: {
    secret: {
      type: String,
      default: ''
    },
    taxiInfo: {
      type: Object,
      default: () => {}
    },
    taxiPrice: {
      type: [Object, Array],
      default: () => {}
    },
    indexBooking: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isOpenPopup: false,
      step: 1,
      isEmailValidate: true,
      timeDisappears: 5000,
      taxiService: {},
      creditAmount: 0,
      taxiCurrency: ''
    }
  },
  computed: {
    ...mapGetters({
      Services: 'Home/Services'
    }),
    Taxi() {
      return _.find(this.Services, { service_id: 4 })
    }
  },
  watch: {
    taxiPrice: {
      handler() {
        this.creditAmount = this.Taxi.taxi_booking_detail[this.$route.query.indexBooking ?? this.indexBooking].est_amount
      },
      deep: true
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    replaceStr,
    validateEmail: function (email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    initData() {
      let self = this
      this.taxiService = _.find(this.Services, { service_id: 4 })
      if (this.taxiPrice) {
        this.creditAmount = this.Taxi.taxi_booking_detail[this.$route.query.indexBooking ?? this.indexBooking].est_amount
      }
      //important: please check airport config currency first
      self.taxiCurrency = self.taxiService.currency
    },
    onOpenEmailPopup: function () {
      this.isOpenPopup = !this.isOpenPopup
      this.step = 1
    },
    resetEmailValidate: function () {
      this.isEmailValidate = true
    },
    totalClaimed: function () {
      if (this.taxiInfo.list_receipt.length) {
        let total = this.taxiInfo.list_receipt.reduce((previousValue, currentValue) => {
          return previousValue + parseFloat(currentValue.amount)
        }, 0)
        return total
      }
      return 0
    },
    sendEmailConfirm: function () {
      var self = this
      if (!this.validateEmail(this.pax.email_address)) {
        this.isEmailValidate = false
        return
      }
      let dataSend = {
        data: {
          email: this.pax.email_address,
          credit: this.Taxi.price_per_person,
          claimed: this.totalClaimed().toFixed(2),
          transferred: this.taxiInfo.bank_info.target_amount,
          currency: this.taxiInfo.bank_info.currency,
          full_name: this.pax.full_name,
          iban:
            this.taxiInfo.bank_info.transfer_bank_info[' I B A N'] ||
            this.taxiInfo.bank_info.transfer_bank_info['Account Number'],
          transferId: this.taxiInfo.bank_info.transfer_id,
          secret: self.secret,
          block_code: this.taxiInfo.bank_info.block_code || '',
          voucher_code: this.taxiInfo.bank_info.voucher_code || ''
        },
        secret: self.secret
      }
      this.$store.dispatch('sendEmailConfirmReceipt', dataSend).then((response) => {
        if (response) {
          if (response.success == false) {
            this.isOpenPopup = !this.isOpenPopup
            return
          }
          this.step = 2
          setTimeout(
            function () {
              self.isOpenPopup = false
            },
            self.timeDisappears,
            self
          )
        }
      })
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2)
      return val.toString()
    }
  }
}
</script>
